module.exports = __webpack_public_path__ + "img/FR18719.315847fd.png";